/* SkyCommerce galaxy motion */
(function(){
  try {
    var m=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)');
    if(m&&m.matches)return;
    document.documentElement.classList.add('galaxy-on');
    function reveal(){
      var els=document.querySelectorAll('.galaxy-on .shopify-section');
      if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in');});return;}
      var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('is-in');io.unobserve(x.target);}});},{threshold:0.12,rootMargin:'0px 0px -40px 0px'});
      els.forEach(function(e){io.observe(e);});
      setTimeout(function(){els.forEach(function(e){e.classList.add('is-in');});},2500);
    }
    if(document.readyState!=='loading')reveal();else document.addEventListener('DOMContentLoaded',reveal);
  }catch(e){document.documentElement.classList.remove('galaxy-on');}
})();
